import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '../services/translate.service';
import {TITLE_SUFFIX} from '../translate.suffix';
import {Observable} from 'rxjs';

@Pipe({
  name: 'cpTitleTranslate',
  pure: true
})
export class TitleTranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) { }

  transform(query: string, args: any[] = []): Observable<string> {
    return this.translateService.transform(
      this.translateService.containsRegisteredTranslateSuffix(query) ? query : query + TITLE_SUFFIX, ...args);
  }
}
